module.exports = __webpack_public_path__ + "img/pageBg.188fc168.png";